import { CapturedAction } from '@/app/shared/utils/logger';
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';

export const MAX_ACTIONS = 10;
export const actions: CapturedAction[] = [];

export function pushAction(action: CapturedAction) {
  actions.push(action);

  if (actions.length > MAX_ACTIONS) {
    actions.splice(0, actions.length - MAX_ACTIONS);
  }
}

export function getRecentActions(): CapturedAction[] {
  return [...actions];
}

export interface ApiResponse<T> {
  ok: boolean;
  data: T | null;
  errors?: string[];
}

export type BaseQueryWithReauth = BaseQueryFn<
  string | FetchArgs,
  ApiResponse<unknown>,
  FetchBaseQueryError
>;

export const extractData = <T>(response: ApiResponse<T>) => response.data;

export function getUniqueByLowestId<T extends { id: number }>(
  items: T[],
  getKey: (item: T) => string
): T[] {
  const map = items.reduce<Record<string, T>>((acc, item) => {
    const key = getKey(item);

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!acc[key] || item.id < acc[key].id) {
      acc[key] = item;
    }

    return acc;
  }, {});

  return Object.values(map);
}

export function isBaseQueryError(
  error: unknown
): error is { error: { status?: number; data?: unknown } } {
  return (
    typeof error === 'object' &&
    error !== null &&
    'error' in error &&
    typeof error.error === 'object' &&
    error.error !== null &&
    'status' in error.error &&
    'data' in error.error
  );
}
